require('team-admin')
angular.module('team-admin')
  .filter('trustedUrl', function($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url)
    }
  })
